declare function escape(s:string): string;
export class CommonUtil {
    
    public static cutByte (str:string, len:number) : string {
		var flag = false;
        if(str == undefined){
			return "";
		} else {
            var count = 0;
            for(var i = 0; i < str.length; i++) {
				if(escape(str.charAt(i)).length >= 4)
					count += 2;
				else
					if(escape(str.charAt(i)) != "%0D")
						count++;
				if(count >  len) {
					//if(escape(str.charAt(i)) == "%0A")
					count = len;
					flag = true
					break;		
				}
			}
			if(flag){
				return str.substring(0, count) + "...";
			} else {
				return str.substring(0, count);
			}
        }
    }
}


// WEBPACK FOOTER //
// C:/Users/sung/WebstormProjects/exafe front/src/app/utility/CommonUtil.ts